module.exports = __webpack_public_path__ + "img/today.54e8b501.png";